/*
 * @Description: 文件内容
 * @Author: dali
 * @Date: 2021-04-09 09:53:04
 * @LastEditors: 肖申平
 * @LastEditTime: 2024-07-26 10:11:59
 */
import React, { useEffect, useState } from 'react'
import styles from './productChoose.scss'
import Container from '@/components/container'
import FlexRowCon from '@/components/flexRowCon'
import SectionTitle from '@/components/sectionTitle'
import ProductItem from './product'
import { getProds } from './productChoose'
import wrapWithUser from '@/components/wrapWithUser'
// import User from '../../modules/user'
import { SYSCON } from '@/const/const'
import Expense from '@/pages/expense'

const ProductChoose = (props) => {
  const [prodVisible, handleProdVisible] = useState(false)
  // const [prodId, handleProdId] = useState(false)
  const [prodList, handleProdList] = useState([])
  // const user = new User()
  // 初始化
  useEffect(()=>{
    async function getProdsList() {
      await props.user.getProdList(SYSCON.PlatAppSmarterFin).catch((err)=>{
        console.log('getProdListerr', err)
      })
      handleProdVisible(true)
      getProds().then(res => {
        handleProdList(res)
      })
    }
    // getProdId()
    getProdsList()
  }, [])

  // const getProdId = ()=> {
  //   user.getProductId()
  //     .then(prodId => {
  //       handleProdId(prodId)
  //     })
  //     .catch(err => {
  //       console.log('err', err)
  //     })
  // }
  const getFreePerd = (title) => {
    const prod = props.user.getProdsByTitle(title)
    return (+prod.freeTrialPerd || 0)
  }
  return (
    <section id='product-choose' className={styles['product']}>
      <Container>
        <FlexRowCon>
          <SectionTitle title={'产品选择'} />
        </FlexRowCon>
        <FlexRowCon className={styles['product-col']}>
          {prodList.map((p, idx) => {
            return (
              <div className={styles['col-3']} key={idx} >
                <ProductItem key={idx} {...p} freeTrialPerd={prodVisible ? getFreePerd(p.title) : false}/>
              </div>
            )
          })}
        </FlexRowCon>

      </Container>
      <Expense />
    </section>
  )
}

export default wrapWithUser(ProductChoose)
